import PrimaryCell from "../../../../ui/Table/Cells/PrimaryCell";
import DateTimeCell from "../../../../ui/Table/Cells/DateTimeCell";
import ExpertiseStatusCell from "./Cells/ExpertiseStatusCell";

export const columns = [
  {
    dataField: "id",
    caption: "ID",
    dataType: "string",
    cellRender: PrimaryCell,
    width: 60
  },
  {
    dataField: "statusDate",
    caption: "Дата",
    dataType: "string",
    cellRender: DateTimeCell,
    width: 100
  },
  {
    dataField: "programType",
    caption: "Тип",
    dataType: "string",
    cellRender: PrimaryCell,
    width: 70
  },
  {
    dataField: "programCode",
    caption: "Код",
    dataType: "string",
    cellRender: PrimaryCell,
    width: 100
  },
  {
    dataField: "programName",
    caption: "Программа/Модуль",
    dataType: "string",
    cellRender: PrimaryCell,
    width: 280
  },
  {
    dataField: "programOwnerName",
    caption: "Правообладатель",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "skillName",
    caption: "Компетенция",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "specName",
    caption: "Профессия/Специальность",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "status",
    caption: "Статус",
    dataType: "string",
    cellRender: ExpertiseStatusCell,
    width: 80
  },
];
